import { Box, Button, Container, DialogActions, DialogContent, DialogTitle, Paper } from '@mui/material';
import React from 'react';
export const EditModeDialog = (props) => {
    var _a, _b, _c, _d, _e;
    return (React.createElement(Container, { maxWidth: ((_a = props.config.modal) === null || _a === void 0 ? void 0 : _a.maxWidth) === 'full' ? false : (_b = props.config.modal) === null || _b === void 0 ? void 0 : _b.maxWidth, sx: {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
        } },
        React.createElement(Paper, { elevation: 4, sx: { m: 2, width: ((_c = props.config.modal) === null || _c === void 0 ? void 0 : _c.fullWidth) ? '100%' : undefined } },
            (props.config.modal.title || props.config.label) && (React.createElement(DialogTitle, null, props.config.modal.title || props.config.label)),
            React.createElement(DialogContent, { sx: { overflow: 'visible' } },
                React.createElement(Box, { pt: 1 }, props.children)),
            React.createElement(DialogActions, null,
                React.createElement(Button, { color: 'primary', tabIndex: -1 }, (_d = props.config.modal.cancelButtonLabel) !== null && _d !== void 0 ? _d : 'Cancel'),
                React.createElement(Button, { color: 'primary', tabIndex: -1 }, (_e = props.config.modal.saveButtonLabel) !== null && _e !== void 0 ? _e : 'Save')))));
};
